export default __webpack_public_path__ + "static/media/logo.51586d6b.svg";